import React, { useState } from 'react';
import ProductMappingTable from './ProductMappingTable';
import { Vendor } from './types';

interface VendorDetailsProps {
  vendor: Vendor;
  onClose: () => void;
  onEdit: () => void;
  onRefresh: () => void;
}

const VendorDetails: React.FC<VendorDetailsProps> = ({
  vendor,
  onClose,
  onEdit,
  onRefresh
}) => {
  const [activeTab, setActiveTab] = useState<'info' | 'products'>('info');

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content vendor-details-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="vendor-title">
            <h3>{vendor.vendorName}</h3>
            <code className="vendor-id">{vendor.vendorId}</code>
          </div>
          <div className="header-actions">
            <button className="btn btn-warning" onClick={onEdit}>
              ✏️ Edit
            </button>
            <button className="modal-close" onClick={onClose}>✕</button>
          </div>
        </div>

        <div className="modal-tabs">
          <button
            className={`tab-button ${activeTab === 'info' ? 'active' : ''}`}
            onClick={() => setActiveTab('info')}
          >
            📋 Vendor Info
          </button>
          <button
            className={`tab-button ${activeTab === 'products' ? 'active' : ''}`}
            onClick={() => setActiveTab('products')}
          >
            📦 Products ({vendor.products.length})
          </button>
        </div>

        <div className="modal-body">
          {activeTab === 'info' && (
            <div className="vendor-info">
              <div className="info-section">
                <h4>Basic Information</h4>
                <div className="info-grid">
                  <div className="info-item">
                    <label>Vendor ID:</label>
                    <span><code>{vendor.vendorId}</code></span>
                  </div>
                  <div className="info-item">
                    <label>Vendor Name:</label>
                    <span><strong>{vendor.vendorName}</strong></span>
                  </div>
                  <div className="info-item">
                    <label>Total Products:</label>
                    <span>{vendor.products.length}</span>
                  </div>
                </div>
              </div>

              <div className="info-section">
                <h4>Timestamps</h4>
                <div className="info-grid">
                  <div className="info-item">
                    <label>Created:</label>
                    <span>{formatDate(vendor.createdAt)}</span>
                  </div>
                  <div className="info-item">
                    <label>Last Updated:</label>
                    <span>{formatDate(vendor.updatedAt)}</span>
                  </div>
                </div>
              </div>

              {vendor.products.length > 0 && (
                <div className="info-section">
                  <h4>Product Summary</h4>
                  <div className="product-summary">
                    <div className="summary-stats">
                      <div className="stat-item">
                        <span className="stat-number">{vendor.products.length}</span>
                        <span className="stat-label">Total Products</span>
                      </div>
                      <div className="stat-item">
                        <span className="stat-number">
                          {new Set(vendor.products.map(p => p.materialId)).size}
                        </span>
                        <span className="stat-label">Unique Material IDs</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {activeTab === 'products' && (
            <div className="vendor-products">
              <ProductMappingTable
                vendor={vendor}
                onRefresh={onRefresh}
                readOnly={true}
              />
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
          <button className="btn btn-primary" onClick={onEdit}>
            Edit Vendor
          </button>
        </div>
      </div>
    </div>
  );
};

export default VendorDetails;
